import { useEffect } from 'react'
import { onConsentChanged } from '@/lib/analytics'
import { initBotpress } from '@/lib/botpress'
import { useAuthStore } from '@/features/auth/store'

/** Monte le webchat Botpress dès que le consentement cookies est donné. */
export function BotpressChat() {
  const userId = useAuthStore((s) => s.user?.id)

  useEffect(() => {
    initBotpress(userId)
    return onConsentChanged(() => initBotpress(userId))
  }, [userId])

  return null
}
